import { render, staticRenderFns } from "./ActiveSellers.vue?vue&type=template&id=81df04cc&"
import script from "./ActiveSellers.vue?vue&type=script&lang=js&"
export * from "./ActiveSellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports